import * as XLSX from 'sheetjs-style';
import * as FileSaver from 'file-saver';
import JsonHelper from './JsonHelper';

class AttendeeHelper {
    static export = (records, params) => {
        let workbook = {
            Sheets: {
                'attendees': XLSX.utils.json_to_sheet(records.map(record => this.convertToExportRecord(record, params)))
            },
            SheetNames: ['attendees']
        };

        let buffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        let blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
        FileSaver.saveAs(blob, 'attendees.xlsx');
    }

    static convertToExportRecord = (item, params, settings) => {
        const lng = settings.intl.locale;
        params.settings = params.attendees.settings; // dirty tmp quick fix 15/07/2026

        // Set general data
        let record = {
            id: item.id,
            client: item.client.internal_id,
            first_name: item.first_name,
            last_name: item.last_name,
            membership_enabled: item.membership.enabled
        };

        if (params.settings.fields && Object.keys(params.settings.fields).length > 0) {
            if (params.settings.fields.email) record.email = item.email;
            if (params.settings.fields.phone) record.phone = item.phone;
            if (params.settings.fields.national_insurance_number) record.national_insurance_number = item.national_insurance_number;
            if (params.settings.fields.gender) record.gender = item.gender;
            if (params.settings.fields.birth_date) record.birth_date = item.birth_date;
            if (params.settings.fields.medical_info) record.medical_info = item.medical_info;
        }

        if (params.settings.membership_webshop_discount_code) {
            record.webshop_discount_code = item.webshop_discount_code
        }

        if (params.settings.use_membership) {
            record.membership_enabled = item.membership.enabled ? 1 : 0;
            record.membership_status = settings.intl.formatMessage({ id: 'CMS.Attendee.overview.table.status.' + item.status });
            record.membership_expires = item.membership.expires?.format('YYYY-MM-DD');
            record.membership_paid = item.membership.paid?.format('YYYY-MM-DD')
        }

        if (params.additionalFields?.length) {
            params.additionalFields.forEach(field => {
                let fieldContent = field.contents.find(content => content.language === lng);

                if (field.has_prefix_choices) {
                    let prefixValue = item.additionalFieldValues[field.field_key + '__prepend'];
                    record['additionalfield_value__' + field.field_key + '__prepend|' + fieldContent.label + '_prefix'] = prefixValue;
                }

                let value = item.additionalFieldValues[field.field_key];
                if (field.field_type === 'editor') value = JsonHelper.tryParse(value)?.text;
                record['additionalfield_value__' + field.field_key + '|' + fieldContent.label] = value;

                if (field.has_suffix_choices) {
                    let suffixValue = item.additionalFieldValues[field.field_key + '_append'];
                    record['additionalfield_value__' + field.field_key + '__append_|' + fieldContent.label + '_suffix'] = suffixValue;
                }
            })
        }

        return record;
    }

}

export default AttendeeHelper;